<template>
  <v-container fluid class="payment-home-page pa-0">
    <div
      v-if="!$vuetify.breakpoint.xsOnly"
      class="payment-chart-section mb-4"
    >
      <PaymentMethodLine />
    </div>

    <List />
  </v-container>
</template>

<script>
import PaymentMethodLine from "@/modules/Customer/Payment/Chart/PaymentMethodLine";
import List from "@/modules/Customer/Payment/components/PaymentList.vue";

export default {
  name: "payment-home",

  components: {
    PaymentMethodLine,
    List,
  },
};
</script>

<style scoped>
.payment-home-page {
  background: #f8fafc;
}

.payment-chart-section {
  border-radius: 20px;
  overflow: hidden;
}

@media (max-width: 600px) {
  .payment-home-page {
    padding: 0 !important;
  }
}
</style>